import React from 'react'
import SimpleBanner from '../Common/SimpleBanner'
import AboutUs_banner from '../../Assets/About/banaraimg.png'
import Form from '../../Components/Contact/Form'
import Card from '../../Components/Contact/Card'
// import Map from '../../Components/Contact/Map'
import SubscribeTo from '../../Components/home/SubscribeTo'
const Contact = () => {
  return (
    <div className='overflow-x-hidden tracking-wide'>
     <SimpleBanner
        image={AboutUs_banner}
        name="Contact"
        path="Home / Contact"
      />

      <Form />
      <Card />
      {/* <Map/> */}
      <SubscribeTo/>
    </div>
  )
}

export default Contact;